import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Table, Tag, Tooltip } from "antd";
import { EditOutlined, EyeInvisibleOutlined, PlusOutlined } from "@ant-design/icons";

import api from "../../services/api";
import { useStateValue } from "../../state";
import { Editar } from "../../components";
import DrawerEquipamento from "./drawerEquipamento";
import ModalVisualizaSenha from "./modalVisualizaSenha";

export default function TabEquipamento({ formulario }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [editando, setEditando] = useState(false);
    const [equipamentoSelecionado, setEquipamentoSelecionado] = useState(formulario.getFieldValue("eqp_id"));
    const [dadosEditando, setDadosEditando] = useState([]);
    const [listaEquipamentos, setListaEquipamentos] = useState([]);
    const [openDrawerEqui, setOpenDrawerEqui] = useState(false);
    const [openModalSenha, setOpenModalSenha] = useState(false);
    const [dadosSenha, setDadosSenha] = useState([]);

    useEffect(() => {
        carregarEquipamentos();
    }, [])

    useEffect(() => {
        setEquipamentoSelecionado(formulario.getFieldValue("eqp_id"));
    }, [formulario]);

    function carregarEquipamentos() {
        let idCliente = formulario.getFieldValue().cli_id
        api.get(`EquipamentoCliente/Listar?cli_id=${idCliente}&PageSize=1000&PageNumber=1`).then(
            res => {
                let retorno = res.data.items;
                setListaEquipamentos(retorno);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )
    }

    function editandoEquipamento(dados) {
        setDadosEditando(dados);
        setEditando(true);
    }

    function visualizaSenha(dados) {
        setDadosSenha(dados);
        setOpenModalSenha(true);
    }

    function selecionarEquipamento(eqp_id) {
        setEquipamentoSelecionado(eqp_id);
        formulario.setFieldsValue({ eqp_id: eqp_id });

    }

    async function filtroPesquisa(value) {
        let idCliente = formulario.getFieldValue().cli_id;
        let filtro = value || formulario.getFieldValue().filtroPor || '';
        api.get(`EquipamentoCliente/Listar?cli_id=${idCliente}&Filtro=${filtro}`).then(
            res => {
                let retorno = res.data.items;
                setListaEquipamentos(retorno);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )
    }

    const rowSelection = {
        type: "radio",
        selectedRowKeys: equipamentoSelecionado ? [equipamentoSelecionado] : [],
        onChange: (selectedKeys) => selecionarEquipamento(selectedKeys[0]),
    };


    return (
        <div className="p-10">
            <Col className="col-mob-100">
                <Row align="middle" justify="space-between" style={{ marginBottom: '20px' }}>

                    <Col xs={24} sm={16} md={16} lg={14} xl={14} xxl={16}>
                        <Form.Item label="Pesquisar por:" name="filtroPor">
                            <Input.Search placeholder={"Código, Tipo de Equipamento, Modelo do Equipamento"}
                                onSearch={(value) => { filtroPesquisa(value) }}
                                allowClear />
                        </Form.Item>
                    </Col>
                    <Col style={{ marginLeft: '10px' }}>
                        <Button type="primary" icon={<PlusOutlined />} size="middle" onClick={() => setOpenDrawerEqui(true)}>
                            NOVO
                        </Button>
                    </Col>
                </Row>
            </Col>
            <div className="tabela">
                <Table
                    dataSource={listaEquipamentos}
                    rowKey="eqp_id"
                    pagination={{ pageSize: 10 }}
                    rowSelection={rowSelection}
                    onRow={(record) => ({
                        onClick: () => selecionarEquipamento(record.eqp_id),
                    })}
                    columns={[
                        {
                            title: 'Código',
                            width: 50,
                            align: 'center',
                            render: ({ eqp_id }) => (
                                <Tag color="processing" className="w-100">
                                    <b>{eqp_id}</b>
                                </Tag>
                            ),
                        },
                        {
                            title: 'Descrição',
                            render: ({ eqp_descricao }) => {
                                return (
                                    <div>
                                        <b>
                                            {eqp_descricao}
                                        </b>
                                    </div>
                                );
                            },
                        },
                        {
                            title: 'Identificação',
                            render: ({ eqp_identificacao }) => {
                                return (
                                    <div>
                                        <b>
                                            {eqp_identificacao}
                                        </b>
                                    </div>
                                );
                            },
                        },

                        {
                            title: 'Tipo de Equipamento',
                            render: ({ descricao_tipo }) => {
                                return (
                                    <div>
                                        <b>
                                            {descricao_tipo}
                                        </b>
                                    </div>
                                );
                            },
                        },
                        {
                            title: 'Ações',
                            dataIndex: '',
                            key: 'x',
                            align: 'center',
                            width: 95,
                            fixed: 'right',
                            render: (dados) => (
                                <div>
                                    <Row align="middle" justify="center" gutter={[5, 0]}>
                                        <Col>
                                            <Tooltip title="Editar">
                                                <Editar
                                                    onClick={() => {
                                                        editandoEquipamento(dados);
                                                    }} icon={<EditOutlined />}
                                                />
                                            </Tooltip>
                                        </Col>
                                        <Col>
                                            <Tooltip title="Visualizar senha">
                                                <Button
                                                    onClick={() => {
                                                        visualizaSenha(dados);
                                                    }}
                                                    icon={<EyeInvisibleOutlined />}
                                                />
                                            </Tooltip>
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                    ]} />
            </div>
            <DrawerEquipamento editando={{ editando, setEditando }} equipamento={manutencao.dados} formulario={formulario} dadosEditando={dadosEditando}
                openDrawerEqui={openDrawerEqui} setOpenDrawerEqui={setOpenDrawerEqui} carregarEquipamentos={carregarEquipamentos} />
            <ModalVisualizaSenha editando={{ editando, setEditando }} formulario={formulario}
                exibirModal={openModalSenha} fecharModal={() => setOpenModalSenha(false)} dadosSenha={dadosSenha} aoSalvar={() => carregarEquipamentos()} />
        </div>
    );
}